import React from 'react';
import { Phone, ShieldCheck } from 'lucide-react';
import { companyInfo, images, phoneDigits, whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={images.hero} alt="Bicos injetores diesel" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/85 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-36 pb-24 w-full">
        <div className="max-w-3xl">
          <span className="inline-block text-[#FF6B00] font-bold text-sm uppercase tracking-wider px-4 py-2 bg-[#FF6B00]/10 rounded-full border border-[#FF6B00]/40 mb-6">
            Especialistas em Diesel
          </span>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]" data-testid="hero-title">
            Injeção Diesel em <span className="text-[#FF6B00]">São Gonçalo – RJ</span>
          </h1>

          <p className="text-base md:text-lg text-gray-100 mb-10 leading-relaxed drop-shadow-[0_1px_4px_rgba(0,0,0,0.9)] max-w-2xl" data-testid="hero-subtitle">
            {companyInfo.tagline}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-button"
              className="bg-[#25D366] text-white px-8 py-4 rounded-md hover:bg-[#1fb857] transition-all duration-300 font-bold text-lg flex items-center justify-center gap-3 transform hover:scale-105 shadow-[0_0_25px_rgba(37,211,102,0.35)]"
            >
              <WhatsAppIcon className="w-6 h-6" />
              Chamar no WhatsApp
            </a>
            <a
              href={`tel:+55${phoneDigits}`}
              data-testid="hero-call-button"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-md hover:bg-white hover:text-[#0a0a0a] transition-all duration-300 font-semibold text-lg flex items-center justify-center gap-3"
            >
              <Phone size={22} />
              Ligar agora
            </a>
          </div>

          <p className="mt-6 flex items-center gap-2 text-sm text-gray-200" data-testid="hero-warranty">
            <ShieldCheck className="text-[#FF6B00]" size={18} />
            Garantia de 90 dias em todos os serviços
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
